import UsersDB  from "@/firebase/users-db";
import firebase from "firebase";

const getRandomArbitrary = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);

    return Math.floor(Math.random() * (max - min + 1)) + min;
};

/**
 * Create new user from firebase auth user infos
 */
// eslint-disable-next-line
export const createNewUserFromFirebaseAuthUser = async firebaseAuthUser => {
          const providerData                   = firebaseAuthUser.providerData[0];
          const {displayName, photoURL, email} = providerData;
          const userDb                         = new UsersDB();
          const user                           = {
              displayName,
              photoURL,
              email,
              notificationMethod: false,
              phoneNumber       : "",
              role              : ""
          };
          let randomAvatar                     = "";

          try {
              const storage   = firebase.storage();
              const avatarRef = storage.refFromURL(`gs://rr-staging-ebbc7.appspot.com/avatars/${getRandomArbitrary(
                  1,
                  40
              )}.png`);

              randomAvatar = await avatarRef.getDownloadURL();
          } catch (e) {
              console.error(e);
          }

          user.displayName = user.displayName !== null ? user.displayName : user.email;
          user.photoURL    = user.photoURL !== null ? user.photoURL : randomAvatar;
          user.avatar      = ``;

          return userDb.create(user, firebaseAuthUser.uid);
      };
